<ol class="breadcrumb float-xl-right">
    <li class="breadcrumb-item">Inicio</li>
    <li class="breadcrumb-item">Administración de Campos</li>
</ol>

<h1 class="page-header"><i class="fas fa-tachometer-alt"></i> Administración de Campos</h1>

<panel [noButton]="true">
    <div class="row">
        <div class="d-flex justify-content-end pr-5">
            <button class="btn btn-primary btn-sm" (click)="open(modalCampusForm)">Nuevo Campo</button>
        </div>
    </div>
    <div class="row">
        <div class="table-responsive">
        <table class="table table-sm table-striped table-hover my-5">
            <thead>
                <tr>
                    <th class="text-center">N°</th>
                    <th>Nombre</th>
                    <th>Sigla</th>
                    <th>Tipo</th>
                    <th class="text-center">Orden</th>
                    <th class="text-center">Habilitado</th>
                    <th class="text-center"><i class="fas fa-cogs"></i></th>
                </tr>
            </thead>
            <tbody>
                @for(office of campus; track $index; let i = $index){
                <tr>
                    <td class="text-center align-middle">{{ i + 1 }}</td>
                    <td class="align-middle">{{ office.name }}</td>
                    <td class="align-middle">{{ office.acronym }}</td>
                    <td class="align-middle">{{ office.type?.name }}</td>
                    <td class="text-center align-middle">
                        <div class="d-flex gap-2 justify-content-center">
                            <button class="btn btn-outline-secondary btn-xs py-0 px-1" [disabled]="i === 0"
                                (click)="moveUp(i)" title="Subir posición">
                                <i class="fas fa-angle-up"></i>
                            </button>
                            <button class="btn btn-outline-secondary btn-xs py-0 px-1" [disabled]="i === campus.length - 1"
                                (click)="moveDown(i)" title="Bajar posición">
                                <i class="fas fa-angle-down"></i>
                            </button>
                        </div>
                    </td>
                    <td>
                        <div class="form-check form-switch d-flex justify-content-center">
                            <input class="form-check-input" type="checkbox" id="checkbox1" [checked]="office.enabled" (change)="enabledCampus(office)"/>
                        </div>
                    </td>
                    <td class="text-center">
                        <button class="btn btn-xs btn-primary mx-2" (click)="open(modalCampusForm, office)"
                            ngbTooltip="Revisar Evaluación"><i class="fas fa-eye"></i></button>

                    </td>

                </tr>
                }
                @empty{
                <tr>
                    <td colspan="7" class="text-center">No hay registros</td>
                </tr>

                }
            </tbody>
        </table>
        </div>
    </div>
</panel>


<ng-template #modalCampusForm let-c="close" let-d="dismiss">

    <div class="modal-header">
        <span class="fs-3 fw-700">Datos Usuario</span>
    </div>
    <div class="modal-body" [formGroup]="newCampusForm">
        <div class="row mb-3">

            <div class="col-md-6">
                <label class="form-label col-form-label col-md-3">Nombre</label>
                <input type="text" class="form-control" placeholder="Nombre" formControlName="name" />
            </div>
            <div class="col-md-6">
                <label class="form-label col-form-label col-md-3">Sigla</label>
                <input type="text" class="form-control" placeholder="Sigla" formControlName="acronym" />
            </div>
            <div class="col-md-6">
                <label class="form-label col-form-label col-md-3">Tipo</label>
                <ng-select [items]="listTypesCampus" formControlName="typeId" bindLabel="name" bindValue="_id" [clearable]="true" appendTo="body" dropdownPosition="auto"></ng-select>
            </div>
        </div>

    </div>

    <div class="modal-footer">
        <button class="btn btn-danger" (click)="d('Cross click')">Cerrar</button>
        <button class="btn btn-primary" (click)="d('Cross click'); saveCampus()">Guardar</button>
    </div>
</ng-template>